import {
  FETCH_API_KEYS,
  FETCH_API_KEY_DETAIL,
  CREATE_API_KEY,
  REVOKE_API_KEY,
  REACTIVATE_API_KEY,
  DELETE_API_KEY,
  CLEAR_NEW_API_KEY,
} from './apiKeyActions';

const initialState = {
  apiKeys: [],
  currentApiKey: null,
  newApiKey: null, // Store the full key only once when created
  isLoading: false,
  isCreating: false,
  isRevoking: false,
  isReactivating: false,
  isDeleting: false,
  error: null,
};

const apiKeyReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch API Keys List
    case FETCH_API_KEYS.REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case FETCH_API_KEYS.SUCCESS:
      return {
        ...state,
        isLoading: false,
        apiKeys: action.payload,
        error: null,
      };
    case FETCH_API_KEYS.FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    // Fetch API Key Detail
    case FETCH_API_KEY_DETAIL.REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case FETCH_API_KEY_DETAIL.SUCCESS:
      return {
        ...state,
        isLoading: false,
        currentApiKey: action.payload,
        error: null,
      };
    case FETCH_API_KEY_DETAIL.FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    // Create API Key
    case CREATE_API_KEY.REQUEST:
      return {
        ...state,
        isCreating: true,
        error: null,
      };
    case CREATE_API_KEY.SUCCESS:
      return {
        ...state,
        isCreating: false,
        newApiKey: action.payload, // Store full key with visible key value
        apiKeys: [action.payload, ...state.apiKeys],
        error: null,
      };
    case CREATE_API_KEY.FAILURE:
      return {
        ...state,
        isCreating: false,
        error: action.payload,
      };

    // Clear new API key (after user has saved it)
    case CLEAR_NEW_API_KEY:
      return {
        ...state,
        newApiKey: null,
      };

    // Revoke API Key
    case REVOKE_API_KEY.REQUEST:
      return {
        ...state,
        isRevoking: true,
        error: null,
      };
    case REVOKE_API_KEY.SUCCESS:
      return {
        ...state,
        isRevoking: false,
        apiKeys: state.apiKeys.map((key) =>
          key.id === action.payload.apiKeyId
            ? { ...key, is_active: false, revoked_at: new Date().toISOString() }
            : key
        ),
        error: null,
      };
    case REVOKE_API_KEY.FAILURE:
      return {
        ...state,
        isRevoking: false,
        error: action.payload,
      };

    // Reactivate API Key
    case REACTIVATE_API_KEY.REQUEST:
      return {
        ...state,
        isReactivating: true,
        error: null,
      };
    case REACTIVATE_API_KEY.SUCCESS:
      return {
        ...state,
        isReactivating: false,
        apiKeys: state.apiKeys.map((key) =>
          key.id === action.payload.apiKeyId
            ? { ...key, is_active: true, revoked_at: null }
            : key
        ),
        error: null,
      };
    case REACTIVATE_API_KEY.FAILURE:
      return {
        ...state,
        isReactivating: false,
        error: action.payload,
      };

    // Delete API Key
    case DELETE_API_KEY.REQUEST:
      return {
        ...state,
        isDeleting: true,
        error: null,
      };
    case DELETE_API_KEY.SUCCESS:
      return {
        ...state,
        isDeleting: false,
        apiKeys: state.apiKeys.filter((key) => key.id !== action.payload.apiKeyId),
        error: null,
      };
    case DELETE_API_KEY.FAILURE:
      return {
        ...state,
        isDeleting: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default apiKeyReducer;
